import { useContext } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { LanguageContext } from "../../../context/LanguageContext";

import "swiper/css";
import "swiper/css/pagination";

export default function Marketplace() {
  const { t, isRTL } = useContext(LanguageContext);
  const slides = t("marketplace.slides", { returnObjects: true }) || [];

  return (
    <section dir={isRTL ? "rtl" : "ltr"} className="bg-white py-24">
      <div className="mx-auto max-w-7xl px-6">

        {/* Header */}
        <div className="mb-16 text-center">
          <h2 className="text-4xl font-bold text-gray-900">
            {t("marketplace.title")}
          </h2>
          <p className="mt-4 text-gray-600">
            {t("marketplace.subtitle")}
          </p>
        </div>

        {/* Slider */}
        <Swiper
          modules={[Autoplay, Pagination]}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          spaceBetween={24}
          breakpoints={{
            640: { slidesPerView: 1 },
            1024: { slidesPerView: 2 },
          }}
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>
              <PricingCard {...slide} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

function PricingCard({ title, subtitle, highlight, points, cta }) {
  return (
    <div className="flex h-full flex-col rounded-2xl border border-gray-200 bg-gray-50 p-8 shadow-sm">
      <h3 className="text-2xl font-semibold text-gray-900">
        {title}
      </h3>

      <p className="mt-2 text-gray-600">
        {subtitle}
      </p>

      <div className="mt-6 rounded-xl bg-rose-50 px-4 py-3 text-lg font-bold text-rose-600">
        {highlight}
      </div>

      <ul className="mt-6 space-y-3 text-gray-700">
        {points.map((point, index) => (
          <li key={index} className="flex items-start gap-2">
            <span className="mt-1 text-rose-500">✓</span>
            <span>{point}</span>
          </li>
        ))}
      </ul>

      <button className="mt-auto rounded-xl bg-rose-600 px-6 py-3 font-semibold text-white transition hover:bg-rose-700">
        {cta}
      </button>
    </div>
  );
}
